export const SET_APPUSER = "setAppUser";
export const SET_APPUSERS = "setAppUsers";
export const APPUSERS_RESET = "appUsersReset";
export const APPUSER_RESET = "appUserReset"
export const SET_APPUSER_ACTIVE = "setAppUserActive"
export const SET_APPUSER_PAGINATION = "setAppUserPagination"